import React from "react";
import { ExlyDatePicker } from "common/form";

import ExlyModal from "common/Components/ExlyModal";
import useStyles from "./styles";
import { UPDATE_EXPIRY_MODAL_FORM_KEYS } from "./UpdateExpiryModal.constants";
import { useUpdateExpiryModal } from "./hooks/useUpdateExpiryModal";
import moduleStyle from "./UpdateExpiryModal.module.css";

const UpdateExpiryModal = ({
  open,
  onClose,
  onSave,
  endDate,
  startDate = null,
  sessionName,
  customerName,
  showStartDate = false,
  endDateLabel = "Expiry Date",
  modalTitle,
  modalSubTitle,
}) => {
  const classes = useStyles();
  const {
    expiry_date,
    start_date,
    toPickerDate,
    handleExpiryDateChange,
    handleStartDateChange,
  } = useUpdateExpiryModal({ open, endDate, startDate, showStartDate });

  const renderDatePicker = (dateString, fieldName, onChange) => (
    <ExlyDatePicker
      input={{
        name: fieldName,
        value: toPickerDate(dateString),
        onChange,
      }}
      meta={{}}
      calendarOnly
      popperClassName="tw-z-[10]"
      fullWidth
    />
  );

  if (!open) return null;

  return (
    <ExlyModal
      open={open}
      onClose={onClose}
      title={modalTitle ?? `Change ${endDateLabel}`}
      onPrimaryBtnClick={() =>
        onSave(expiry_date, showStartDate ? start_date : undefined)
      }
      primaryBtnText="Update"
      modal_props={{ modalPaperClassName: moduleStyle.desktopModalPaper }}
      mobile_modal_props={{ paperClassName: moduleStyle.mobileModalPaper }}
    >
      <div className={classes.expiryContentWrap}>
        <div className={classes.content}>
          <span>
            {modalSubTitle ??
              `Change ${endDateLabel.toLowerCase()} of ${sessionName} for ${customerName}`}
          </span>
        </div>

        {showStartDate && (
          <>
            <div className={`${classes.dataLabel}`}>Start Date</div>
            {renderDatePicker(
              start_date,
              UPDATE_EXPIRY_MODAL_FORM_KEYS.start_date,
              handleStartDateChange
            )}
          </>
        )}

        <div className={classes.dataLabel}>{endDateLabel}</div>
        {renderDatePicker(
          expiry_date,
          UPDATE_EXPIRY_MODAL_FORM_KEYS.expiry_date,
          handleExpiryDateChange
        )}
      </div>
    </ExlyModal>
  );
};

export default UpdateExpiryModal;
